import React, { useEffect, useState } from "react";
import "./BoxSelectionComponent.css";
import defaultBox from "../../../images/img/default-box.png";
import ScrollerWithArrows from "../../../Simplify360Chat/CommonUtils/ScrollerWithArrows";
export default function BoxSelectionComponent(props) {
  const { data, code, tag, onClickHandler, filterToggle } = props;

  const [boxData, setBoxData] = useState(data);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    boxData.map((bData) => (bData.checked = false));
  }, []);

  const boxSelectionClickHandler = (box) => {
    var newBoxData = [];
    if (box.checked === false) {
      for (let i = 0; i < boxData.length; i++) {
        if (boxData[i].boxId === box.boxId) {
          boxData[i].checked = true;
        } else {
          boxData[i].checked = false;
        }
        newBoxData.push(boxData[i]);
      }
      setBoxData(newBoxData);

      //make other values reverse
    } else {
      for (let i = 0; i < boxData.length; i++) {
        if (boxData[i].boxId === box.boxId) {
          boxData[i].checked = false;
        } else {
          boxData[i].checked = false;
        }
        newBoxData.push(boxData[i]);
      }
      setBoxData(newBoxData);
    }
  };
  const onSubmitHandler = () => {
    const selectedBox = boxData
      .filter((box) => box.checked === true)
      .map((box) => box.boxId);
    onClickHandler(code, { key1: selectedBox[0] }, tag);
    filterToggle && filterToggle(true);
  };
  const boxLocationStyles = {
    marginBottom: "2%",
    marginTop: "-3%",
    color: "#444",
  };
  const boxSelectionLineStyles = {
    width: "65px",
    borderTop: "1px solid grey",
    marginTop: "-12px",
    marginBottom: "11px",
    marginLeft: "31.5px",
  };
  return (
    <div className="BoxSlectionContainer">
       <ScrollerWithArrows width="100%" height="12rem" >
      <div className="BoxSelection-Scroller">
        {boxData.length > 0 &&
          boxData.map((box, index) => {
            return (
              <div
                value={box}
                key={index}
                className="BoxSelection"
                style={{
                  border:
                    box.checked === true
                      ? "1px solid #E10092"
                      : "1px solid #d6caca",
                      width:'40%'
                }}
                onClick={() => boxSelectionClickHandler(box)}
              >
                <div className="BoxSelection-Radio">
                  <input
                    style={{ cursor: "pointer" }}
                    onChange={() => console.log(box.boxId)}
                    type="radio"
                    name="box"
                    id={box.boxId}
                    value={box.id}
                    checked={box.checked}
                  />
                </div>
                <div className="BoxSelection-room" style={boxLocationStyles}>
                  {box.location === "" ? "Box Location" : box.location}
                  
                </div>
                <div className="BoxSelection-boxId">
                  <span>Box ID:</span>
                  {box?.boxId?.substr(box?.boxId?.length - 4)}
                </div>

                <div className="BoxSelection-image">
                  <img
                    src={box.imageLink}
                    alt=""
                    height="40px"
                    width={"65px"}
                    onError={(e) => (e.target.src = defaultBox)}
                  />
                </div>
                <div style={boxSelectionLineStyles}></div>
                <hr className="hrContainer" />

                <div className="BoxSelection-boxType">({box.description})</div>
              </div>
            );
          })}
      </div>
      </ScrollerWithArrows>
      <div className="BoxSelection-button">
        <button
          className="BoxSelection-button-submit waves-effect waves-light"
          onClick={() => onSubmitHandler()}
        >
          Add To Box
        </button>
        {/* <button
          className="BoxSelection-button-submit waves-effect waves-light back-styling"
          
        >
          Back
        </button> */}
      </div>
    </div>
  );
}